import { toast } from "sonner";
import { ArrowLeft, ArrowRight, PencilLine, Trash2 } from "lucide-react";
import { api, errText } from "@/lib/api";

export const ItemTools = ({ item, i, list, kind, reload }) => {
  const b = "flex h-8 w-8 items-center justify-center text-white hover:bg-[#E62314] disabled:opacity-30";
  const move = async (d) => {
    const ids = list.map((x) => x.id);
    [ids[i], ids[i + d]] = [ids[i + d], ids[i]];
    try { await api.put("/gallery/order", { ids }); reload(); } catch (e) { toast.error(errText(e)); }
  };
  const rename = async () => {
    const t = window.prompt("Title shown on this item (leave empty for none):", item.title || "");
    if (t === null) return;
    try { await api.put(`/gallery/${item.id}`, { title: t }); reload(); } catch (e) { toast.error(errText(e)); }
  };
  const remove = async () => {
    if (!window.confirm(`Remove this ${kind === "video" ? "video" : "photo"} from the gallery?`)) return;
    try { await api.delete(`/gallery/${item.id}`); reload(); toast.success("Removed"); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="absolute right-3 top-3 z-20 flex overflow-hidden rounded-full bg-[#0A0A0A]/90 shadow-lg" onClick={(e) => e.stopPropagation()} data-testid={`gallery-tools-${item.id}`}>
      <button className={b} disabled={i === 0} onClick={() => move(-1)} aria-label="Move earlier"><ArrowLeft className="h-4 w-4" /></button>
      <button className={b} disabled={i === list.length - 1} onClick={() => move(1)} aria-label="Move later"><ArrowRight className="h-4 w-4" /></button>
      <button className={b} onClick={rename} aria-label="Edit title" data-testid={`gallery-rename-${item.id}`}><PencilLine className="h-4 w-4" /></button>
      <button className={b} onClick={remove} aria-label="Remove" data-testid={`gallery-delete-${item.id}`}><Trash2 className="h-4 w-4" /></button>
    </div>
  );
};
